module.exports = __webpack_public_path__ + "static/media/accept-invitation.5ea0acc8.svg";